import Vue from "vue";
import Vuex, { ModuleTree } from "vuex";

Vue.use(Vuex);

const modulesFiles = require.context("./modules", true, /\.ts$/);
// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles
  .keys()
  .reduce((modules: ModuleTree<unknown>, modulePath) => {
    // set './app.ts' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
    const value = modulesFiles(modulePath);
    modules[moduleName] = value.default;
    return modules;
  }, {});

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules,
});
